import React, { ReactNode } from 'react';
import { ProgramData } from '@src/typings/mfeCatalogTools';
import { clickable } from '@src/analytics';
import ProgramCard from '@src/remotes/CatalogTools/ProgramCard/ProgramCard';
import ProgramCardProvider from '@src/remotes/CatalogTools/ProgramCardProvider/ProgramCardProvider';
import './ProgramCardList.scss';

type ProgramCardType = 'bookmarks' | 'recommendations';

export interface ProgramCardListProps {
  programCardType: ProgramCardType;
  programs: ProgramData[];
  renderIfEmpty: ReactNode;
}

/**
 * Displays an iterated list of Program Cards or an empty component if the list has no length
 * ```tsx
 *
 *  <ProgramCardList programCardType='bookmarks' programs={programs} renderIfEmpty={<p>I am an empty list</p>}>
 *    I will render above the program list, unless the list is empty
 *  <ProgramCardList/>
 *
 * ```
 * @packageDocumentation
 */
const ProgramCardList: React.FC<ProgramCardListProps> = ({
  programCardType,
  programs,
  renderIfEmpty,
  children,
}) => {
  const programUuids = programs.map((program) => program.uuid);

  return programs.length > 0 ? (
    <div className='ProgramCardList'>
      {children}
      <ProgramCardProvider programUuids={programUuids}>
        {programs.map((program) => {
          return (
            <ProgramCard
              key={program.uuid}
              product='home'
              program={program}
              onClick={() =>
                clickable({
                  product: 'home',
                  loggedIn: true,
                  tag: 'learn_skills',
                  text: `${programCardType}_learn_more`,
                  type: 'button',
                })
              }
            />
          );
        })}
      </ProgramCardProvider>
    </div>
  ) : (
    <>{renderIfEmpty}</>
  );
};

export default ProgramCardList;
